import React, { useEffect, useState } from 'react';
import '../../styles/layout/landing.scss';
import logo from '../../images/ISACA_logo_rev_RGB.png';
import LandingPageText from './LandingPageText';
import Page from './Page';

const LandingPage = () => {
  const [loginUrl, setLoginUrl] = useState('');
  const pageTitle = 'Login';

  useEffect(() => {
    if (process.env.LOCAL_DEVELOPMENT_LOGIN) {
      setLoginUrl('/developmentLogin');
    } else {
      setLoginUrl(process.env.API_BASE_URL + '/sso/login');
    }
  }, []);

  return (
    <Page title={pageTitle} className='reset-padding'>
      <div className='landing-page'>
        <div className='container-one'>
          <div className='info-column'>
            <div className='intro'>
              <h2 className='introducing'>Introducing</h2>
              <h1 className='title'>Voluntary Improvement Program (VIP) Portal</h1>
            </div>
            <LandingPageText />
            <img className='container-logo' src={logo} alt='ISACA-logo' />
          </div>
        </div>
        <div className='container-two'>
          <div className='text-block-login'>
            <h2 className='title'>Welcome!</h2>
            <button className='button-login'>
              <a href={loginUrl} className='button-login-link'>
                <h3 className='button-login-text'>Sign In</h3>
              </a>
            </button>
            <div className='account-contact'>
              <span>
                Don&apos;t have an account?{' '}
                <a href='https://forms.office.com/r/WKzQEywWWW'>Contact Us </a>
                to learn
                <br /> more about an annual license.
              </span>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default LandingPage;
